import { render, staticRenderFns } from "./TableFamilies.vue?vue&type=template&id=e439a202&scoped=true&"
import script from "./TableFamilies.vue?vue&type=script&lang=js&"
export * from "./TableFamilies.vue?vue&type=script&lang=js&"
import style0 from "./TableFamilies.vue?vue&type=style&index=0&id=e439a202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e439a202",
  null
  
)

export default component.exports